import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_right",
  "use": "svg_right-usage",
  "viewBox": "0 0 9 15",
  "content": "<symbol viewBox=\"0 0 9 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg_right\"><path d=\"M0 2.346 1.379.969 8.409 8 7.032 9.377.001 2.346Z\" fill=\"currentColor\" /><path d=\"M6.964 6.66 8.34 8.036 1.377 15 0 13.623l6.964-6.964Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol